<template>
  <div class="saved-table-list">
    <h3>Saved Tables</h3>
    <ul>
      <li v-for="(table, index) in savedTables" :key="index">
        <strong>Table {{ index + 1 }}</strong>
        <div>
          <v-btn small class="mx-2" @click="$emit('edit-table', index)">Edit</v-btn>
          <v-btn small class="mx-2" @click="$emit('delete-table', index)">Delete</v-btn>
        </div>
        <iframe ref="savedTableIframe" class="savedTableIframe" width="100%" height="500"></iframe>
      </li>
    </ul>
    <GeneratedTable v-if="type == 'table'" />
  </div>
</template>

<script>
import GeneratedTable from "../components/GeneratedTable.vue";

export default {
  components: {
    GeneratedTable,
  },
  props: {
    savedTables: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    updateSavedTableIframe(index) {
      const tableData = this.savedTables[index].table;
      const doc = this.$refs.savedTableIframe[index].contentDocument;
      doc.open();
      doc.write(
        `<html>
          <head>
            <style>
              .table {
                border-collapse: collapse;
                width: 100%;
              }
              .table th {
                background-color: #f2f2f2;
                border: 1px solid #ddd;
                padding: 8px;
                text-align: left;
              }
              .table td {
                border: 1px solid #ddd;
                padding: 8px;
              }
            </style>
          </head>
          <body>
            <div class="table-container">
              <table class="table">
                <thead>
                  <tr>
                    ${tableData.headers
                      .map((header) => `<th>${header}</th>`)
                      .join("")}
                  </tr>
                </thead>
                <tbody>
                  ${tableData.rows
                    .map(
                      (row) =>
                        `<tr>${row
                          .map((cell) => `<td>${cell}</td>`)
                          .join("")}</tr>`
                    )
                    .join("")}
                </tbody>
              </table>
            </div>
          </body>
        </html>`
      );
      doc.close();
      const iframeNode = this.$refs.savedTableIframe[index];
      iframeNode.height = doc.documentElement.scrollHeight + 20;
    },
  },
  mounted() {
    this.savedTables.forEach((table, index) => {
      this.updateSavedTableIframe(index);
    });
  },
  watch: {
    savedTables: {
      deep: true,
      handler() {
        this.savedTables.forEach((table, index) => {
          this.updateSavedTableIframe(index);
        });
      },
    },
  },
};
</script>

<style scoped>
.saved-table-list {
  background-color: #f5f5f5;
  padding: 20px;
  border-radius: 5px;
}

.saved-table-list ul {
  list-style-type: none;
  padding: 0;
}

.saved-table-list li {
  margin-bottom: 20px;
}

.saved-table-list h3 {
  margin-bottom: 10px;
}
</style>
